import { getAppConfiguration } from '@utils/browserEnv';
import { Card } from 'antd';
import { ChevronRight } from 'lucide-react';
import React, { FC } from 'react';
import { SanityImage } from 'sanity-image';
import styles from './MakerCard.module.scss';
import { MakerCardProps } from './MakerCard.props';

const { projectId, dataset } = getAppConfiguration();

const MakerCard: FC<MakerCardProps> = ({ maker }) => (
  <div>
    <Card hoverable className={styles.card}>
      <div className={styles.image}>
        {maker.logo?.asset?._ref ? (
          <SanityImage
            id={maker.logo.asset._ref}
            projectId={projectId}
            dataset={dataset}
            width={170}
            height={112}
            alt={`${maker.name} logo`}
          />
        ) : (
          <img src="/images/no-image-placeholder.svg" alt="placeholder" width={170} height={112} />
        )}
      </div>
      <div className={styles.titleWrapper}>
        <h3 className={styles.title}>{maker?.name}</h3>
        <ChevronRight size={16} className={styles.icon} />
      </div>
    </Card>
  </div>
);

export { MakerCard };
